import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { Provider } from './../../../../types';
import { toast } from 'react-toastify';
import { updateProviderById} from '../../../../../../../../crud/management_api/providers';
import './UpdateProvider.scss';



const UpdateProvider: React.FC<any> = ({
      showEditModal,
      setShowEditModal,
      setCurrentData,
      currentData,
      currentProvider
    }) => {
  
      const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.currentTarget;
      if (!form) {
      console.error('Form not found.');
      return;
        }

      // Validación de campos obligatorios
      const requiredFields = [
        { key: 'provider_name', label: 'Nombre' }
      ];
      const missingFields = requiredFields.filter(field => {
        const value = form[field.key]?.value;
        return !value || value.trim() === '';
      });
      if (missingFields.length > 0) {
        const missingLabels = missingFields.map(f => f.label).join(', ');
        toast.error(`Por favor completa los siguientes campos: ${missingLabels}`);
        return;
      }

      const userContext = localStorage.getItem('user');
      const companyId = userContext != null ? JSON.parse(userContext).company_id : 0;
      const edit_Provider: any = {
        provider_id: currentProvider.provider_id,
        company_id: companyId,
        name: form.provider_name.value,
        number: form.number.value || null,
        email: form.email.value || null,
        numero_tributario: form.numero_tributario.value || null
      };
        updateProviderById(Number(edit_Provider.provider_id), edit_Provider)
          .then((response: any) => {
            const updatedProv: Provider = response.data;
            toast.success('Proveedor actualizado con éxito!');
            setShowEditModal(false);
            // Update the current data
            const updatedData = currentData.map((provider: Provider) => {
              if (provider.provider_id === currentProvider.provider_id) {
                return updatedProv;
              }
              return provider;
            });
            setCurrentData(updatedData);
          })
          .catch(error => {
            console.error('Error al actualizar al proveedor:', error);
            toast.error(error.response?.data?.message || 'Error al actualizar al proveedor');
          });
    };
  
      return (
          <Modal className="update-provider-modal" show={showEditModal} onHide={() => setShowEditModal(false)}>
            <Form onSubmit={handleFormSubmit}>
              <Modal.Header>
              <div className='form-modal-title-container'>
                <Modal.Title className='form-modal-title'>Actualizar proveedor</Modal.Title>
              </div>
                <Button variant="none" className="modal-close-button" onClick={() => setShowEditModal(false)}>
                  <X size={24} />
                </Button>
              </Modal.Header>
              <Modal.Body>
                <Form.Group controlId="provider_name" className='mp-formgroup'>
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control type="text" name="name" placeholder="Nombre del proveedor" defaultValue={currentProvider?.name} required />
                </Form.Group>

                <Form.Group controlId="email" className='mp-formgroup'>
                  <Form.Label>Correo electrónico</Form.Label>
                  <Form.Control type="email" name="email" placeholder="correo@ejemplo.com" defaultValue={currentProvider?.email} />
                </Form.Group>

                <div className="horizontal-fields-row">
                  <Form.Group controlId="number" className='mp-formgroup'>
                    <Form.Label>Número</Form.Label>
                    <Form.Control type="text" name="number" placeholder="+1-555-0123" defaultValue={currentProvider?.number} />
                  </Form.Group>
                  <Form.Group controlId="numero_tributario" className='mp-formgroup'>
                    <Form.Label>Número Tributario</Form.Label>
                    <Form.Control type="text" name="numero_tributario" placeholder="12-3456789" defaultValue={currentProvider?.numero_tributario} />
                  </Form.Group>
                </div>
              </Modal.Body>
              <Modal.Footer>
              <div className="form-modal-footer-custom">
                <Button className="form-button-cancel" onClick={() => setShowEditModal(false)}>Cancelar</Button>
                <Button className="form-button-create" type="submit">Actualizar</Button>
              </div>
              </Modal.Footer>
            </Form>
          </Modal>
        );
    };

export default UpdateProvider;

